module.exports = __webpack_public_path__ + "static/media/Quicksand_Light.555cd799.otf";